export const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/`;
// Admin
export const API_ADMIN_CARDS_VIRTUAL = "admin/cards/virtual";
export const API_ADMIN_FEES = "admin/fees";
export const API_ADMIN_GET_ADMIN_BALANCE = "admin/get-admin-balance";
export const API_ADMIN_GET_BALANCE = "admin/get-balance";
export const API_ADMIN_GET_REMAIN = "admin/get-remain";
export const API_ADMIN_INFO = "admin/info";
export const API_ADMIN_SET_FEE = "admin/set-fee";
export const API_ADMIN_WALLET = "admin/wallet";
export const API_ADMIN_WALLET_EDIT = "admin/wallet/edit";

// Agent
export const API_AGENT_CHANGE_USER = "agent/change-user";
export const API_AGENT_CREATE = "agent/create";
export const API_AGENT_LIST = "agent/list";
export const API_AGENT_TRANSACTION_LIST = "agent/transaction/list";
export const API_AGENT_TRANSACTIONS_LIST = "agent/transactions/list";
export const API_AGENT_UPDATE = "agent/update";
export const API_AGENTS_BALANCE = "agents/balance";
export const API_PARTNER_CREATE = "partner-authorize";

// Card
export const API_CARD_DETAIL = "card/detail";
export const API_CARD_GET_LIMITS = "card/get-limits";
export const API_CARD_GET_STATUS = "card/get-status";
export const API_CARD_SEND_EMAIL = "card/send-email";
export const API_CARD_SET_LIMITS = "card/set-limits";
export const API_CARD_TOPUP = "card/topup";
export const API_CARD_TRANSACTIONS = "card/transactions";
export const API_CARD_UPDATE_STATUS = "card/update-status";

// Cards
export const API_CARDS_ADD_CARD = "cards/add-card";
export const API_CARDS_CREATE_CREDIT_CARD = "cards/create-credit-card";
export const API_CARDS_CREATE_CREDIT_CARD_WITH_BOT =
  "cards/create-credit-card-with-bot";
export const API_CARDS_CREATE_PHYSICAL_CARD = "cards/create-physical-card";
export const API_CARDS_LIST_PHYSICAL = "cards/list/physical";
export const API_CARDS_LIST_VIRTUAL = "cards/list/virtual";

// Users
export const API_ALL_USERS = "all-users";
export const API_CREATE = "create";
export const API_CREATE_USER = "create/user";
export const API_LIST = "list";
export const API_DELETE = "delete";
export const API_EDIT = "edit";
export const API_UPDATE = "update";

// Currency
export const API_CURRENCIES = "currencies";
export const API_CURRENCY_SPREAD = "currency-spread";
export const API_CURRENCY_SPREAD_TYPES = "currency-spread/types";
export const API_CURRENCY_SPREAD_DETAIL = "currency-spread/{currency_spread}";

// Document
export const API_DOCUMENT_DOWNLOAD = "document-download";
export const API_DOCUMENT_UPLOAD = "document-upload";

// Elastic / Elito
export const API_ELASTIC_MONITOR_STATUS = "elastic-monitor/status";
export const API_ELITO_USERS_CONFIRMED = "elito-users/list/confirmed";
export const API_ELITO_USERS_PENDING = "elito-users/list/pending";
export const API_ELITO_CARD_ORDERS = "elito/card-orders";

// Exchange
export const API_EXCHANGE_RATE_AGENT_LIST = "exchange/rate/agent-list";
export const API_EXCHANGE_RATE_CREATE = "exchange/rate/create";
export const API_EXCHANGE_RATE_DELETE = "exchange/rate/delete";
export const API_EXCHANGE_RATE_LIST = "exchange/rate/list";

// Fee
export const API_FEE_ADMIN_CALCULATE = "fee/admin/calculate";
export const API_FEE_CALCULATE = "fee/calculate";

// Forgot
export const API_FORGOT_STEP_ONE = "forgot-step-one";
export const API_FORGOT_STEP_TWO = "forgot-step-two";
export const API_FORGOT_STEP_THREE = "forgot-step-three";

// General
export const API_GENERAL_GET_CITY = "general/get-city";
export const API_GENERAL_GET_COUNTRY = "general/get-country";
export const API_GENERAL_GET_EVENT = "general/get-event";
export const API_GENERAL_GET_OCCUPATION = "general/get-occupation";
export const API_GENERAL_GET_STATE = "general/get-state";
export const API_GENERAL_GET_TIMEZONES = "general/get-timezones";

// KYC
export const API_KYC_CHANGE_STATUS_FIELD = "kyc/changeStatusField";
export const API_KYC_CONFIRM = "kyc/confirm";
export const API_KYC_LIST = "kyc/list";
export const API_KYC_PREMIUM = "kyc/premium";
export const API_KYC_STARTER = "kyc/starter";

// Logs
export const API_LOG_ACTIVITY_LIST = "log/activity/list";
export const API_LOG_DASHBOARD_ACTIVITY_LIST = "log/dashboard/activity/list";
export const API_LOG_LIST = "log/list";
export const API_LOG_PEP_LIST = "log/pep/list";

// Auth
export const API_LOGIN = "login";
export const API_LOGOUT = "logout";

// Mail
export const API_MAIL_SEND = "mail/send";
export const API_SEND_EMAIL_NOTIFICATION = "send-email-notification";

// PDF
export const API_PDF_PREVIEW = "pdf/preview";

// PEP
export const API_PEP_BALANCE = "pep/balance";


// Roles
export const API_ROLE_CREATE = "role/create";
export const API_ROLE_DELETE = "role/delete";
export const API_ROLE_LIST = "role/list";
export const API_ROLE_STORE = "role/store";

// Sberbank
export const API_SBERBANK_ADD_TRANSACTION = "sberbank/add-transaction";
export const API_SBERBANK_START = "sberbank/start";
export const API_SBERBANK_UPDATE_TRANSACTION = "sberbank/update-transaction";
export const API_SBERBANK_VERIFY = "sberbank/verify";

// Search
export const API_SEARCH = "search";
export const API_SEARCH_ADMINS = "search-admins";

// Settings
export const API_SETTING = "setting";
export const API_SETTING_MAILERS = "setting/mailers";
export const API_SETTING_UPDATE_MAILER = "setting/update-mailer";
export const API_SETTING_UPDATE_NUMBERLAND_LIMIT =
  "setting/update-numberland-limit";

// Topup
export const API_TOPUP_AGENT_LIST = "topup/agent/list";
export const API_TOPUP_CARD_LIST = "topup/card/list";
export const API_TOPUP_CREATE = "topup/create";
export const API_TOPUP_CREATE_ADMIN = "topup/create-admin";
export const API_TOPUP_GET_BANKS = "topup/get-banks";
export const API_TOPUP_GET_COUNTRY = "topup/get-country";
export const API_TOPUP_IBAN_CREATE = "topup/iban-create";
export const API_TOPUP_IBAN_DELETE = "topup/iban-delete";
export const API_TOPUP_IBAN_LIST = "topup/iban-list";
export const API_TOPUP_LIST = "topup/list";

// User
export const API_USER_AGENTS = "user/agents";
export const API_USER_CARDS_PLASTIC = "user/cards/plastic";
export const API_USER_CARDS_VIRTUAL = "user/cards/virtual";
export const API_USER_DETAIL = "user/detail";
export const API_USER_DOCUMENTS = "user/documents";
export const API_USER_FEES = "user/fees";
export const API_USER_FORCE_DELETE = "user/force-delete";
export const API_USER_GET_BADGES = "user/get-badges";
export const API_USER_GET_SETTINGS = "user/get-settings";
export const API_USER_INFO = "user/info";
export const API_USER_SET_FEE = "user/set-fee";
export const API_USER_SET_SETTINGS = "user/set-settings";
export const API_USER_TRANSACTIONS = "user/transactions";
export const API_USER_WALLET = "user/wallet";
export const API_USER_WALLET_EDIT = "user/wallet/edit";

// Users
export const API_USERS_BALANCE = "users/balance";
export const API_USERS_DEFAULT_ADD = "users/default/add";
export const API_USERS_DEFAULT_DELETE = "users/default/delete";
export const API_USERS_DEFAULT_GET = "users/default/get";
export const API_USERS_DEFAULT_UPDATE = "users/default/update";
export const API_USERS_DEFAULTFEE_ADD = "users/defaultFee/add";
export const API_USERS_DEFAULTFEE_CHECK = "users/defaultFee/check";
export const API_USERS_DEFAULTFEE_DELETE = "users/defaultFee/delete";
export const API_USERS_DEFAULTFEE_GET = "users/defaultFee/get";
export const API_USERS_DEFAULTFEE_UPDATE = "users/defaultFee/update";
export const API_USERS_LIST = "users/list";
export const API_USERS_LIST_APPROVED = "users/list/approved";
export const API_USERS_LIST_DECLINED = "users/list/declined";
export const API_USERS_LIST_PENDING = "users/list/pending";
export const API_USERS_LIST_PREMIUM = "users/list/premium";
export const API_USERS_LIST_STARTER = "users/list/starter";
export const API_USERS_REGISTRATION_COUNT = "users/registration-count";

// Others
export const API_GET_NUMBERLAND_BALANCE = "get-numberland-balance";
export const API_GET_USER_TELEGRAM_ID = "get-user-telegram-id";
export const API_VERIFY = "verify";
export const API_ZARINPAL_LIST = "zarinpal/list";
export const API_UPDATE_TIMEZONE = "update-timezone";
export const API_WEBHOOK = "{token}/webhook";
